var _path, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconAlert = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon--triangle-alert",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  ref: svgRef
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 9,
  x2: 12,
  y2: 13
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 17,
  x2: 12.01,
  y2: 17
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconAlert, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconAlert.6b5afcb6.svg";
export { ForwardRef as ReactComponent };